import script from "./EstimateTemplatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateTemplatePage.vue?vue&type=script&setup=true&lang=js"

import "./EstimateTemplatePage.vue?vue&type=style&index=0&id=1a19655c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a19655c"]])

export default __exports__